import Cookies from 'js-cookie';
import {currentCountry as storeCurrentCountry} from './svelte/current-country';

let countryByIP: string | null | undefined;

async function guessCurrentCountryByIP(): Promise<string | null> {
    if(countryByIP !== undefined)
        return countryByIP;
    await new Promise(resolve => YooconShop.ready(resolve));
    const response = await fetch(`${YooconShop.shop.url}/addresses/by-ip`);
    const data = await response.json();
    const code = data?.country?.iso_code;
    countryByIP = code || null;
    if(countryByIP === undefined)
        return undefined as never;
    return countryByIP;
}

// Das muss `var` sein, und die Konstante muss in der Funktion sein,
// sonst spackt der Safari rum.
var countryByLocale: string | null | undefined;

function guessCurrentCountryByLocale(): string | null {
    const LOCALE2COUNTRY: {[locale: string]: string} = {
        cs: 'CZ',
        de: 'DE',
        'de-AT': 'AT',
        'de-BE': 'BE',
        'de-CH': 'CH',
        'de-DE': 'DE',
        'de-IT': 'IT',
        en: 'GB',
        'en-CA': 'CA',
        'en-GB': 'GB',
        'en-US': 'US',
        es: 'ES',
        fr: 'FR',
        'fr-CA': 'CA',
        'fr-CH': 'CH',
        'fr-BE': 'BE',
        'fr-FR': 'FR',
        hu: 'HU',
        nl: 'NL',
        'nl-BE': 'BE',
        'nl-NL': 'NL',
        it: 'IT',
        pl: 'PL',
        pt: 'PT',
        rm: 'CH',
        ro: 'RO',
    };

    if(countryByLocale !== undefined)
        return countryByLocale;
    const exactLocale = navigator.languages?.[0] ?? navigator.language;
    if(!exactLocale)
        return null;
    const coarseLocale = exactLocale.split('-')[0];
    countryByLocale = LOCALE2COUNTRY[exactLocale] ?? LOCALE2COUNTRY[coarseLocale] ?? null;
    return countryByLocale;
}

function currentCountryByCookie(): string | null {
    return Cookies.get('shippingCountry') || null;
}

export function setCurrentCountry(country: string) {
    Cookies.set('shippingCountry', country, {expires: 7});
    storeCurrentCountry.set(country);
}

export function currentCountry() {
    const country = currentCountryByCookie() || guessCurrentCountryByLocale();
    (globalThis as any).CURRENT_COUNTRY ??= country;
    return country;
}
